export default __webpack_public_path__ + "static/media/recomendation-bg.07862ac4.svg";